import React, { useState, useEffect } from "react"
import { Tabs, Tab, Box, Grid } from "@mui/material"
import DataTable from "@/components/Tables/DataTable"
import { apiFetch } from "@/hooks/apiFetch"
import {
  formatDate,
  formatToDevanagariStyle,
  formatWeek,
} from "@/utilities/helper"
import SalesChart from "@/components/charts/SalesChart"
import DailyReport from "@/components/Reports/Sales/Daily/DailyReport"
import WeeklyReport from "@/components/Reports/Sales/Weekly/WeeklyReport"
import MonthlyReport from "@/components/Reports/Sales/Monthly/MonthlyReport"
import YearlyReport from "@/components/Reports/Sales/Yearly/YearlyReport"
import "react-date-range/dist/styles.css" // main style file
import "react-date-range/dist/theme/default.css" // theme css file
import "rsuite/dist/rsuite.min.css"

const SalesDashboard = () => {
  const [selectedTab, setSelectedTab] = useState("daily")
  return (
    <Box>
      <Tabs
        value={selectedTab}
        onChange={(event, newValue) => setSelectedTab(newValue)}
        variant="fullWidth"
        textColor="primary"
        indicatorColor="primary"
      >
        <Tab label="Daily Sales" value="daily" />
        <Tab label="Weekly Sales" value="weekly" />
        <Tab label="Monthly Sales" value="monthly" />
        <Tab label="Yearly Sales" value="yearly" />
      </Tabs>
      <Box sx={{ p: 3 }}>
        {selectedTab === "daily" && <DailyReport />}
        {selectedTab === "weekly" && <WeeklyReport />}
        {selectedTab === "monthly" && <MonthlyReport />}
        {selectedTab === "yearly" && <YearlyReport />}
      </Box>
    </Box>
  )
}

export default SalesDashboard
